<template>
  <OrganismMap :clubs="clubs" />
</template>

<script>
import OrganismMap from '../../components/organisms/layouts/OrganismMap'

export default {
  name: 'SpaMap',
  components: { OrganismMap },
  meta: {
    theme: 'dark',
  },
  props: {
    context: {
      default: () => {},
      required: false,
      type: Object,
    },
  },
  head() {
    return {
      title: 'Encore SPA в Москве на карте',
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: 'Encore SPA в Москве на карте',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'Откройте SPA-комплекс Encore Fitness в Москве на карте — клуб в Москва-сити с премиум-сауной, бассейном и зоной восстановления. Узнайте адрес и удобный путь к Спа-центру.',
        },
      ],
    }
  },
  computed: {
    clubs() {
      const cityId = this.context.cityId
      return this.$store.getters['modules/content/clubsWithSpa'].filter(({ city }) =>
        cityId !== 'all' ? city.id === cityId : true,
      )
    },
  },
}
</script>
